import React from 'react'

const slaColors: Record<string, string> = {
  Green: '#28a745',
  Orange: '#ffc107',
  Red: '#dc3545',
}

interface SlaIndicatorProps { status?: string | null }

const SlaIndicator: React.FC<SlaIndicatorProps> = ({ status }) => {
  if (!status) return null
  return (
    <span
      title={`SLA: ${status}`}
      style={{
        display: 'inline-block', width: '10px', height: '10px', borderRadius: '50%',
        backgroundColor: slaColors[status] || '#ccc', marginRight: '6px',
      }}
    />
  )
}

export default SlaIndicator
